import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import firebase from 'firebase'

Vue.config.productionTip = false

let app = '';

// Initialize Firebase
firebase.initializeApp({
  apiKey: "AIzaSyCY1vHFB61mBBbtBry4SksuZcWRJ9bYR7M",
  authDomain: "vue-social-login-6073e.firebaseapp.com",
  databaseURL: "https://vue-social-login-6073e.firebaseio.com",
  projectId: "vue-social-login-6073e",
  storageBucket: "",
  messagingSenderId: "498018904992",
  appId: "1:498018904992:web:6e9f63923211d91c"
});

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app');
  }
});
